// extracted by mini-css-extract-plugin
export default {"ns_link":"S1_DeviceCheckConfirm_ns_link__dh8gI","disable_btn":"S1_DeviceCheckConfirm_disable_btn__qmQ0S"};